import styled from 'styled-components';

export const ButtonText = styled.span`
	visibility: ${({ isLoading }) => (isLoading ? 'hidden' : 'visible')};
`;

export const RequestStatus = styled.p`
	font-size: 1.1rem;
	height: 2rem;
	color: ${({ theme, isError }) =>
		isError ? theme.error.color : theme.user.info};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;
